import { render, staticRenderFns } from "./CreateBookmark.form.vue?vue&type=template&id=759c8a0c&scoped=true&lang=pug&"
import script from "./CreateBookmark.form.vue?vue&type=script&lang=ts&"
export * from "./CreateBookmark.form.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBookmark.form.vue?vue&type=style&index=0&id=759c8a0c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c8a0c",
  null
  
)

export default component.exports